"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var crossSizeProperties = (_a = {},
    _a["small" /* Small */] = {
        width: '12px',
        height: '12px',
        viewbox: '0 0 14 14',
    },
    _a["medium" /* Medium */] = {
        width: '16px',
        height: '16px',
        viewbox: '0 0 14 14',
    },
    _a["large" /* Large */] = {
        width: '20px',
        height: '20px',
        viewbox: '0 0 14 14',
    },
    _a);
exports.Cross = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "small" /* Small */ : _b;
    var arrowClassName = classnames_1.default('ty-cross');
    var sizeProps = crossSizeProperties[size || "small" /* Small */];
    return (React.createElement("svg", { width: sizeProps.width, height: sizeProps.height, viewBox: sizeProps.viewbox, className: arrowClassName },
        React.createElement("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            React.createElement("g", { transform: "translate(-1041.000000, -267.000000)", fill: "#D8D8D8", "fill-rule": "nonzero", stroke: "#979797" },
                React.createElement("g", { transform: "translate(612.000000, 248.000000)" },
                    React.createElement("path", { d: "M441.264196,19.4989516 L435.896755,24.8663926 L430.529314,19.4989516 L430.341847,19.6864183 L435.709288,25.0538593 L430.341847,30.4213003 L430.529314,30.6087671 L435.896755,25.241326 L441.264196,30.6087671 L441.451663,30.4213003 L436.084222,25.0538593 L441.451663,19.6864183 L441.264196,19.4989516 Z" }))))));
};
